export default "__VITE_ASSET__D0yI$sjW__"